import { BAIRROS } from "@/data/site";
import { SEO } from "@/components/SEO";
import { BairroCard } from "@/components/BairroCard";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { CTABanner } from "@/components/CTABanner";
import { bairrosImage } from "@/data/site";

export default function Bairros() {
  const regions = [...new Set(BAIRROS.map((b) => b.region))];
  return (
    <>
      <SEO
        title="Bairros Atendidos em São Paulo | Desentupidora Paulistana"
        description="Desentupidora 24h nos bairros nobres de São Paulo: Jardins, Itaim Bibi, Moema, Morumbi, Pinheiros, Higienópolis, Pacaembu e mais. Veja se atendemos sua região."
        path="/bairros"
      />
      <section className="bg-brand-black text-white">
        <div className="max-w-7xl mx-auto container-px py-14">
          <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Bairros" }]} />
          <h1 className="font-display font-black text-4xl sm:text-5xl mt-4 mb-3">Bairros Atendidos</h1>
          <p className="text-gray-300 max-w-2xl">Cobertura completa nas regiões premium de São Paulo, com equipes próximas para chegar até você em minutos.</p>
        </div>
      </section>

      <section className="bg-white">
        <div className="max-w-7xl mx-auto container-px py-16">
          {regions.map((region) => (
            <div key={region} className="mb-10">
              <h2 className="font-display font-extrabold text-xl text-brand-black mb-4 flex items-center gap-2">
                <span className="w-1.5 h-6 bg-brand-red rounded-full" /> {region}
              </h2>
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
                {BAIRROS.filter((b) => b.region === region).map((b) => (
                  <BairroCard key={b.slug} bairro={b} />
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
      <CTABanner />
    </>
  );
}
